import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TableOption } from 'src/app/invopay/interfaces/Iip-table-options';
import { IpRoleService } from 'src/app/invopay/services/ip-role.service';
import { TableEvent } from 'src/app/shared/components/table/Itable';
import { FnPaymentDetailsComponent } from '../fn-payment-details/fn-payment-details.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-fn-payments-ongoing',
  templateUrl: './fn-payments-ongoing.component.html',
  styleUrls: ['./fn-payments-ongoing.component.scss'],
})
export class FnPaymentsOngoingComponent implements OnInit {
  tableOptions!: TableOption;
  type!: 'business' | 'employee' | 'provider';
  propertyOrder: string[] = [];

  constructor(
    public dialog: MatDialog,
    private roleService: IpRoleService,
    private breakpointObserver: BreakpointObserver
  ) {}

  async ngOnInit(): Promise<void> {
    this.type = this.roleService.getType();
    this.propertyOrder = this.setProperty();

    this.tableOptions = {
      keyTranslate: this.setKeyTranslate(),
      selects: [],
      actions: this.setActions(),
      filters: this.setFilters(),
    };
  }

  setKeyTranslate(): string {
    return 'IP.TABLE.PAYMENTS-ONGOING';
  }

  setFilters(): Array<[string, string]> {
    switch (this.type) {
      case 'business':
      case 'provider':
        return [['IP.TABLE.DASHBOARD.FILTER.DATE-ISSUED', 'date']];
      default:
        return [];
    }
  }

  setProperty(): string[] {
    switch (this.type) {
      case 'business':
        return [
          'date',
          'provider_name',
          'idConsolidate',
          'amount',
          'accNumber',
          'invoicesCount',
        ];
      default:
        return [];
    }
  }

  setActions(): Array<string> {
    switch (this.type) {
      case 'business':
        return ['search'];
      default:
        return [];
    }
  }

  async onAction(tableEvent: TableEvent) {
    switch (tableEvent.event) {
      case 'search':
        const { width, minWidth } = this.getDialogDimensions();
        const dialogRef = this.dialog.open(FnPaymentDetailsComponent, {
          height: 'max-content',
          minHeight: '400px',
          maxHeight: '800px',
          width: width,
          minWidth: minWidth,
          panelClass: 'custom-modal',
          data: tableEvent.dataField,
        });

        dialogRef.disableClose = true;
        break;
    }
  }

  private getDialogDimensions() {
    if (this.breakpointObserver.isMatched(Breakpoints.Web)) {
      return { width: 'max-content', minWidth: '50%' };
    } else {
      return { width: 'max-content', minWidth: '80%' };
    }
  }
}
